import React, { useEffect, useState, useContext } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import {
  ThemeProvider,
  createMuiTheme,
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";
import { State } from "../store/state";
import { dismissAlert, getCharity, getCategory } from "../store/actions";

import Alert from "./alert";
import Progress from "./progress";

const App = (props) => {
  const generateClassName = createGenerateClassName({
    seed: "tbcharity",
  });

  const theme = createMuiTheme(props.theme);
  const useStyles = makeStyles((theme) => ({
    main: { paddingTop: theme.spacing(2) },
    image: {
      width: "100%",
    },
    charityName: {
      marginBottom: "5px",
    },
    charityAddress: {
      marginBottom: "5px",
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);

  const getQueryParams = (params, url) => {
    let href = url;
    let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
    let queryString = reg.exec(href);
    return queryString ? decodeURI(queryString[1]) : null;
  };

  useEffect(() => {
    let ein = getQueryParams("ein", location.href);
    getCharity(ein, dispatch).then((charity) => {
      let categoryID = getQueryParams("categoryID", location.href);
      if (categoryID) {
        getCategory(categoryID, dispatch);
      } else {
        let elements = document.querySelectorAll(
          "div.kadence-breadcrumb-container"
        );
        if (elements.length > 0) {
          elements[0].innerHTML = `<span><a href="/" itemprop="url" class="kadence-bc-home"><span>Home</span></a></span><span class="bc-delimiter"> / </span><span><a href="/charities/" itemprop="url"><span>Charities</span></a></span><span class="bc-delimiter"> / </span><span class="kadence-bread-current">${charity.name}</span>`;
        }
      }
    });
  }, []);

  useEffect(() => {
    if (state.charity) {
      let elements = document.querySelectorAll("h1.entry-title");
      if (elements.length > 0) {
        elements[0].innerHTML = state.charity.name;
      }
    }
  }, [state.charity]);

  useEffect(() => {
    if (state.category) {
      let elements = document.querySelectorAll(
        "div.kadence-breadcrumb-container"
      );
      if (elements.length > 0) {
        elements[0].innerHTML = `<span><a href="/" itemprop="url" class="kadence-bc-home"><span>Home</span></a></span><span class="bc-delimiter"> / </span><span><a href="/charities/" itemprop="url"><span>Charities</span></a></span><span class="bc-delimiter"> / </span><span><a href="${state.category.url}" itemprop="url"><span>${state.category.title}</span></a></span><span class="bc-delimiter"> / </span><span class="kadence-bread-current">${state.charity.name}</span>`;
      }
    }
  }, [state.category]);

  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProvider theme={theme}>
        <ScopedCssBaseline className={classes.main}>
          {state.alerts.length > 0 && (
            <Alert
              alert={state.alerts[0]}
              onDismiss={() => {
                dismissAlert(dispatch);
              }}
            />
          )}
          <Progress busy={state.busy} />
          {state.charity && (
            <Grid
              item
              container
              xs={12}
              spacing={2}
              itemScope
              itemType="https://schema.org/Organization"
            >
              <Grid item xs={12} sm={3}>
                <img
                  itemProp="image"
                  alt={state.charity.name + " Charity"}
                  src={state.charity.image}
                  title={state.charity.name}
                  className={classes.image}
                />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography
                  variant="h6"
                  className={classes.charityName}
                  itemProp="name"
                >
                  {state.charity.name}
                </Typography>
                <Typography
                  variant="subtitle2"
                  className={classes.charityAddress}
                >
                  <div
                    itemProp="address"
                    itemScope
                    itemType="https://schema.org/PostalAddress"
                  >
                    <div itemProp="streetAddress">{state.charity.street}</div>
                    <div>
                      <span itemProp="addressLocality">
                        {state.charity.city}
                      </span>
                      ,&nbsp;
                      <span itemProp="addressRegion">
                        {state.charity.state}
                      </span>
                      &nbsp;
                      <span itemProp="postalCode">
                        {state.charity.postalCode}
                      </span>
                    </div>
                  </div>
                </Typography>
                <Typography variant="subtitle1" itemProp="description">
                  {state.charity.description}
                </Typography>
                <Typography variant="subtitle1">{state.charity.ein}</Typography>
              </Grid>
            </Grid>
          )}
        </ScopedCssBaseline>
      </ThemeProvider>
    </StylesProvider>
  );
};
export default App;
